import { useState } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import uuidv1 from 'uuid/v1';
import paymentMethods from '../../../services/api/payment_methods';

import { CardElement, injectStripe } from 'react-stripe-elements';
import Button from './Button';
import { colors, fonts } from '../Theme';

const STYLE_MIN_WIDTH = '500px';

const componentStyles = css`
  @media (min-width: ${STYLE_MIN_WIDTH}) {
    .form {
      display: flex;
    }
  }
`;

const buttonNewPaymentStyles = css.resolve`
  .button-new-payment {
    width: 100%;
  }

  @media (min-width: ${STYLE_MIN_WIDTH}) {
    .button-new-payment {
      margin: 0 0 0 10px;
      padding: 10px 20px;
      width: auto;
    }
  }
`;

const stripeElementStyles = css.resolve`
  .stripe-element {
    padding: 15px 12px;
    flex-grow: 1;
    border: 2px solid ${colors.ywgVeryLightBlue};
    background-color: white;
    font-family: ${fonts.primaryFont};
  }
`;

const AddNewPaymentMethod = ({ profile, addCard, stripe }) => {
  const [error, setError] = useState(false);
  const [stripeElement, setStripeElement] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const newPaymentError = (id, code) => {
    setError({
      msg:
        'Lʼenregistrement de votre nouveau moyen de paiement a échoué, réésayez dans quelques instants.',
      code: code,
      id: id
    });
    setSubmitting(false);
  };

  const onFormSubmit = async e => {
    e.preventDefault();
    const id = uuidv1();
    setSubmitting(true);
    try {
      const { secret } = await paymentMethods.setupPayment(id, profile.email);
      const token = await stripe.handleCardSetup(secret);
      if (token.error) {
        setError({
          msg:
            `Notre banque nous informe que la validation de votre moyen de paiement a échoué avec lʼerreur suivante: ${token.error.message}.` +
            'Vous pouvez réessayer ou changer de moyen de paiement. Dans tous les cas YUPWEGO nʼeffectue aucun débit tant que vous nʼaurez pas confirmé votre souscription à lʼétape suivante.',
          code: token.error.code,
          id: id
        });
      } else {
        if (token && token.setupIntent && token.setupIntent.payment_method) {
          token.id = token.setupIntent.payment_method;
          const response = await paymentMethods.create(token);
          if (response.card) {
            //trackGoal(1, quotation.total);
            //props.onDone(subscriber, response.id, evt);
            const { card } = response;
            addCard({
              id: token.id,
              brand: card.brand,
              last4: card.last4,
              expMonth: card.exp_month,
              expYear: card.exp_year,
              action: 'new'
            });
            stripeElement.clear();
          } else {
            newPaymentError(id, response.code);
          }
        }
      }
      setSubmitting(false);
    } catch (error) {
      newPaymentError(id, error);
      setSubmitting(false);
    }
  };

  return (
    <>
      <h2>Nouveau moyen de paiment</h2>
      <form className="form" onSubmit={onFormSubmit}>
        <CardElement
          className={classnames(
            'stripe-element',
            stripeElementStyles.className
          )}
          onReady={c => setStripeElement(c)}
        />
        <Button
          className={classnames(
            'button-new-payment',
            buttonNewPaymentStyles.className
          )}
          submitting={submitting}
        >
          Ajouter
        </Button>
      </form>
      {error ? (
        <>
          <p>{error.msg}</p>
          <p>
            {' '}
            Si l&apos;erreur persiste, contactez-nous
            <a
              href={`mailto:help@yupwego.com?subject=Eerreur%20lors%20de%20l%27ajout%20d%27une%20carte&body=Bonjour%2C%20%0Aje%20n%27ai%20pas%20pu%20ajouter%20ma%20nouvelle%20carte%20%0ACode%20erreur%20${error.code}%20pour%20la%20souscription%20${error.id}`}
            >
              📧 help@yupwego.com
            </a>
          </p>
        </>
      ) : null}
      <style jsx>{componentStyles}</style>
      {stripeElementStyles.styles}
      {buttonNewPaymentStyles.styles}
    </>
  );
};

AddNewPaymentMethod.propTypes = {
  profile: PropTypes.object.isRequired,
  addCard: PropTypes.func.isRequired
};

export default injectStripe(AddNewPaymentMethod);
